module.exports = __webpack_public_path__ + "img/help.6082e8a7.svg";